import { OrderLineRelatedDataDto } from "@lib/ShiOneClient";
import { SubtableRow } from "./SubtableRow";
import { renderSubtable, SubtableRecordEntry } from "./renderSubtable";
import { Indentation } from "./rowTypes";

const renderCustomFieldsTable = (
  lineNumber: number,
  rows: OrderLineRelatedDataDto[],
) => {
  const colHeaders = ["Field", "Value"];
  const rowRecords: SubtableRecordEntry[][] = rows.map((row, index) => [
    { key: `${index}-${row.fieldName}`, value: row.fieldName },
    { key: `${index}-${row.valueString}`, value: row.valueString },
  ]);

  return renderSubtable(
    colHeaders,
    rowRecords,
    `Line # ${lineNumber}: Custom Fields`,
  );
};

type Props = Indentation & {
  lineNumber: number | undefined;
  relatedData: OrderLineRelatedDataDto[] | undefined;
  colSpan?: number;
};

export function ProductCustomFields({
  xWidth,
  xGap,
  lineNumber,
  relatedData,
  colSpan = 6,
}: Readonly<Props>) {
  if (!lineNumber || !relatedData?.length) {
    return null;
  }
  return (
    <SubtableRow
      title="Custom Fields"
      xWidth={xWidth}
      xGap={xGap}
      colSpan={colSpan}
    >
      {renderCustomFieldsTable(lineNumber, relatedData)}
    </SubtableRow>
  );
}

export default ProductCustomFields;
